import { SingleToolAppIcon } from '../../common/SingleToolAppIcon';

import useStyles from './styles';
import ResultsCategory from './ResultsCategory';
import ResultsContainer from './ResultsContainer';
import { IResultsProps } from './types';

export default function Results({
  searchText,
  items,
  analytics,
  pageName,
  toolName,
}: IResultsProps) {
  const classes = useStyles();

  return (
    <ResultsContainer>
      <ul className={classes.results}>
        {items.map((item) => (
          <a
            key={item.id}
            className={classes.resultsEntryLink}
            href={item.href}
            onClick={() => {
              analytics && analytics.searchResultsClick(pageName, toolName, item.id);
            }}
          >
            <li className={classes.resultsEntry}>
              <SingleToolAppIcon icon={item.icon} size="xsmall" />
              <span>{item.name}</span>
            </li>
          </a>
        ))}
      </ul>
      <ResultsCategory searchText={searchText} items={items} />
    </ResultsContainer>
  );
}
